import React, { useEffect } from "react";
import Right_panel from "../components/login_signup_Panels/right_panel";
import Left_panel from "../components/login_signup_Panels/left_panel";

import { Grid, Paper, TextField, Button } from "@mui/material";
import { styled } from "@mui/material/styles";

function NewLogin() {
  useEffect(() => {
    document.title = "Login";
  }, []);

  // const ValidationTextField = styled(TextField)({
  //     'fieldset': {
  //       borderColor: 'white',
  //       borderWidth: 1,
  //     },
  //     '& input:valid:focus + fieldset': {
  //       borderLeftWidth: 6,
  //       padding: '4px !important', // override inline-style
  //     },
  //   });
  return (
    <div className="md:grid md:grid-cols-3">
      {/* left panel */}
      <Left_panel isLogin={true} />
      {/* right panel */}
      <Right_panel />
    </div>
  );
}

export default NewLogin;
